export default __webpack_public_path__ + "static/media/GHSI Special Board Minutes 8 July 2022.ed530f75.pdf";